/**
 * abilityVfxFighterMeshes — Shape dispatch for SPY-32 fighter wave (OCP).
 */
import {
  buildDecimate,
  buildCripplingStrike,
  buildApprehend,
  buildNoxianGuillotine
} from './abilityVfxDarius.js';
import {
  buildKnuckleDown,
  buildHaymaker,
  buildFacebreaker,
  buildShowStopper
} from './abilityVfxSett.js';
import {
  buildLeapStrike,
  buildEmpower,
  buildCounterStrike,
  buildGrandmasterArms
} from './abilityVfxJax.js';

const FIGHTER_SHAPE_BUILDERS = {
  decimate: buildDecimate,
  crippling_strike: buildCripplingStrike,
  apprehend: buildApprehend,
  noxian_guillotine: buildNoxianGuillotine,
  knuckle_down: buildKnuckleDown,
  haymaker: buildHaymaker,
  facebreaker: buildFacebreaker,
  show_stopper: buildShowStopper,
  leap_strike: buildLeapStrike,
  empower: buildEmpower,
  counter_strike: buildCounterStrike,
  grandmaster_arms: buildGrandmasterArms
};

/** @returns {object|null} */
export function buildFighterAbilityMesh(THREE, spec) {
  const build = FIGHTER_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
